<div id="sidenav" [class.hidden]="!isOpen">
  <app-annotations-editor [hidden]="mode !== 'annotation'" />
  <app-entity-feature-settings [hidden]="mode !== 'settings'" />
  <app-compilation-browser [hidden]="mode !== 'compilationBrowser'" />
  <app-point-cloud-settings [hidden]="mode !== 'pointCloud'" />
</div>
